import React from "react";
import { motion } from "framer-motion";

const SustainabilityStory = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.2 },
        },
    };

    const fadeUpVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
    };

    const imageVariants = {
        hidden: { opacity: 0, scale: 0.95 },
        visible: { opacity: 1, scale: 1, transition: { duration: 0.9, ease: "easeOut" } },
    };

    return (
        <section className="w-full bg-[#F1F1F1] py-12 sm:py-16 md:py-20 lg:py-24 text-left relative z-10 font-sans overflow-hidden">
            <div className="max-w-[1440px] mx-auto w-full px-5 sm:px-10 lg:px-[80px]">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center w-full">

                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, margin: "-100px" }}
                        variants={imageVariants}
                        className="lg:col-span-6 w-full shrink-0 flex justify-center lg:justify-start"
                    >
                        <div className="w-full max-w-[550px] lg:max-w-none aspect-[4/3] sm:aspect-[3/2] lg:aspect-[4/3] overflow-hidden shadow-sm relative bg-[#030914]">
                            <motion.img
                                whileHover={{ scale: 1.03 }}
                                transition={{ duration: 0.6 }}
                                src="/assets/presence/img2.png"
                                alt="Our sustainability story abstract blue wheel graphics"
                                className="w-full h-full object-cover absolute inset-0"
                            />
                        </div>
                    </motion.div>

                    <motion.div
                        variants={containerVariants}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, margin: "-100px" }}
                        className="lg:col-span-6 w-full flex flex-col min-w-0"
                    >
                        <motion.h2
                            variants={fadeUpVariants}
                            className="text-[20px] md:text-[30px] font-[600] text-[#01386A] mb-4 sm:mb-6 leading-tight tracking-tight"
                        >
                            Our sustainability story
                        </motion.h2>

                        <motion.p
                            variants={fadeUpVariants}
                            className="text-[14px] sm:text-[16px] text-[#49577A] leading-relaxed font-graphik font-[500] break-words"
                        >
                            At Coforge, sustainability is not an adjunct to growth—it is integral to how we build, scale and endure. Guided by our belief that progress must serve both business and society, we are aligning growth with responsible execution and long-term value creation. Our ESG approach is grounded in measurable action: advancing climate responsibility, improving water and waste outcomes, protecting biodiversity, and embedding strong governance across ethics, data security and human rights.
                        </motion.p>
                    </motion.div>

                </div>
            </div>
        </section>
    );
};

export default SustainabilityStory;